module.exports = __webpack_public_path__ + "img/19-vietnam.b1dbda37.svg";